import { render, staticRenderFns } from "./LabelWithButtonContainer.vue?vue&type=template&id=41fbffa6&scoped=true&"
import script from "./LabelWithButtonContainer.vue?vue&type=script&lang=js&"
export * from "./LabelWithButtonContainer.vue?vue&type=script&lang=js&"
import style0 from "./LabelWithButtonContainer.vue?vue&type=style&index=0&id=41fbffa6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fbffa6",
  null
  
)

export default component.exports